import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, CssBaseline } from '@material-ui/core';
import { PersistGate } from 'redux-persist/lib/integration/react';
import LinearProgress from '@material-ui/core/LinearProgress';
import modifiedTheme from './modifiedTheme';

import 'noto-sans-sc/all.css';
import './index.css';
import Application from './App';
import './locales/i18n';
import store, { persistor } from './store';

/**
 * We should define all global app wrappers here.
 */
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <React.Suspense fallback={null}>
        <PersistGate loading={<LinearProgress />} persistor={persistor}>
          <ThemeProvider theme={modifiedTheme}>
            <CssBaseline />
            <Application />
          </ThemeProvider>
        </PersistGate>
      </React.Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
